
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon icon--user",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 28.92c-6.07 0-11.02-4.94-11.02-11.02S23.93 6.89 30 6.89s11.02 4.94 11.02 11.02S36.07 28.92 30 28.92zm0-19.03c-4.42 0-8.02 3.6-8.02 8.02s3.6 8.02 8.02 8.02 8.02-3.6 8.02-8.02-3.6-8.02-8.02-8.02zM40.81 53.11H19.19c-2.67 0-4.84-2.17-4.84-4.84v-3.69c0-.22.02-.45.07-.68.71-8.01 7.53-14.26 15.58-14.26S44.87 35.9 45.58 43.9c.05.24.07.46.07.68v3.69c0 2.67-2.17 4.84-4.84 4.84zM30 32.63c-6.53 0-12.07 5.1-12.6 11.61l-.04.23c-.02.07-.02.09-.02.1v3.69c0 1.01.83 1.84 1.84 1.84H40.8c1.01 0 1.84-.83 1.84-1.84v-3.69c0-.01 0-.04-.02-.1l-.04-.23c-.51-6.51-6.05-11.61-12.58-11.61z"}})])
          )
        }
      }
    